<template>
	<div>
		<!--
        <h2
            class="text-2xl font-semibold text-gray-900 pt-2 pb-2"
        >{{ __('Current buy offers from your region') }}</h2>
        -->
		<div class="grid grid-cols-1 md:grid-cols-3 gap-y-3 gap-x-6">
			<div
				v-for="item in offers"
				:key="item.offer.id"
				class="shadow rounded-xl px-4 pt-3 pb-4 bg-white flex flex flex-col space-y-4"
			>
				<!-- fill="#FCC200" -->

				<!-- top row: icon + x -->
				<div class="flex-grow flex">
					<div
						class="flex-shrink-0 h-18 w-18 p-2 mr-4 border-2"
						:class="
							item.offer.trade == 'SELL'
								? 'rounded-full  border-green-500 text-green-500'
								: 'border-orange-500 text-orange-500'
						"
					>
						<ui-icon
							:name="item.offer.product__type.toLowerCase()"
							fill="currentColor"
							stroke-width="2.5"
						/>
					</div>

					<div class="flex flex-col space-y-2">
						<h3
							class="text-xl font-semibold cursor-pointer"
							v-on:click="maybeBid(item)"
							:class="item.offer.trade == 'SELL' ? 'text-gray-900' : 'text-gray-900'"
						>
							<span>{{ item.offer.qty__mt }} t</span> –
							<span>{{
								$cropOptions.getLocalizedLabel(
									item.offer.product__grade,
									$cropOptions.productGradeOptions
								)
							}}</span>
						</h3>

						<div class="flex-grow text-sm">
							<p>
								<span class="flex-shrink truncate"
									>{{ __("Harvest") }}
									{{ item.offer.product__harvest || __("n.a.") }}</span
								>
							</p>
							<div>
								<div
									v-if="
										item.offer.trade == 'BUY' &&
										item.offer.location__mode == 'DAP' &&
										item.offer.location__optional_transport
									"
								>
									{{
										$cropOptions.getLocalizedLabel(
											"FCA",
											$cropOptions.locationModeOptions
										)
									}}
									<span v-if="user">{{ user.address.city }}</span>
								</div>
								<div v-else>
									{{
										$cropOptions.getLocalizedLabel(
											item.offer.location__mode,
											$cropOptions.locationModeOptions
										)
									}}
									<br />
									{{ item.offer.location__address_city }}
									<span class="whitespace-nowrap" v-if="item.distance_road_km">
										({{ (item.distance_road_km).toFixed(0)}} km)
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="flex md:block lg:flex items-center justify-between gap-x-2">
					<div
						v-if="item.price_estimate"
						class="flex md:block lg:flex flex-col lg:justify-center"
					>
						<div v-if="canSeePrice">
							<div
								v-if="
									user &&
									user.type == 'FARMER' &&
									item.offer.trade == 'BUY' &&
									item.offer.location__mode == 'DAP' &&
									item.offer.location__optional_transport &&
									item.price_estimate
								"
							>
								<div class="whitespace-nowrap font-semibold text-orange">
									{{
										item.price_estimate
											? $cropOptions.formatLocalizedNumber(
													item.price_estimate
											  ) + " €/t"
											: ""
									}}
								</div>
							</div>
							<div v-else>
								<div class="whitespace-nowrap font-semibold text-orange">
									ca. {{ item.price_estimate }} €/t
								</div>

								<ui-tooltip
									class="text-sm xl:text-base font-normal"
									:text="
										__(
											'The FCA price is calculated from the buyer\'s CPT price minus the calculated freight costs of approx. '
										) +
										item.freight_cost_eur +
										' €/t \n (' +
										__('road distance: ') +
										parseFloat(item.distance_km_road).toFixed(0) +
										' km)'
									"
								>
									<template v-slot:label>
										<span class="text-left cursor-help text-gray-500">
											<div class="text-xs">
												Wie setzt sich der Preis zusammen?
											</div>
										</span>
									</template>
								</ui-tooltip>
							</div>
						</div>
					</div>
					<ui-button
						class="ml-auto flex-shrink-0"
						type="primary"
						:label="
							item.offer.trade == 'BUY' ? 'Go to Buy Offer' : 'Go to Sell Offer'
						"
						v-on:click="maybeBid(item)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offers: {
			type: Array,
			required: true,
		},
		user: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
		};
	},
	computed: {
		canSeePrice() {
			return this.acl.see_price;
		},
	},
	methods: {
		maybeBid(item) {
			if (this.acl.can_trade) {
				this.$bus.$emit(
					"toggle-iframe-modal",
					this.$route("bid.create", {
						targetType: item.offer.trade,
						targetId: item.offer.id,
					}),
					true,
					false
				);
			} else {
				this.$bus.$emit("toggle-permission-denied-modal");
			}
		},
	},
};
</script>
